import { render, staticRenderFns } from "./DtTransfer.vue?vue&type=template&id=0c5b9b2a&scoped=true"
import script from "./DtTransfer.vue?vue&type=script&lang=js"
export * from "./DtTransfer.vue?vue&type=script&lang=js"
import style0 from "./DtTransfer.vue?vue&type=style&index=0&id=0c5b9b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5b9b2a",
  null
  
)

export default component.exports